"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VoiceCallBridgeExitReasonEnum = void 0;
var VoiceCallBridgeExitReasonEnum;
(function (VoiceCallBridgeExitReasonEnum) {
    VoiceCallBridgeExitReasonEnum["Reject"] = "REJECT";
    VoiceCallBridgeExitReasonEnum["ContactHangedUp"] = "CONTACT_HANGED_UP";
    VoiceCallBridgeExitReasonEnum["Timeout"] = "TIMEOUT";
    VoiceCallBridgeExitReasonEnum["FULL"] = "FULL";
    VoiceCallBridgeExitReasonEnum["JOINEMPTY"] = "JOINEMPTY";
    VoiceCallBridgeExitReasonEnum["LEAVEEMPTY"] = "LEAVEEMPTY";
    VoiceCallBridgeExitReasonEnum["JOINUNAVAIL"] = "JOINUNAVAIL";
    VoiceCallBridgeExitReasonEnum["LEAVEUNAVAIL"] = "LEAVEUNAVAIL";
})(VoiceCallBridgeExitReasonEnum = exports.VoiceCallBridgeExitReasonEnum || (exports.VoiceCallBridgeExitReasonEnum = {}));
